import { BadgeVariant } from '../helpers/mapBadgeVariant';
import { WebLinkProps } from './WebLink/WebLink';

export type LinkIconName =
  | 'ArrowLeftMd'
  | 'ArrowRightMd'
  | 'ArrowRightTwoMd'
  | 'BuildingThreeMd'
  | 'DocumentLg'
  | 'DocumentMd'
  | 'ExternalLinkMd'
  | 'HomeMd'
  | 'LinkLg'
  | 'LinkMd'
  | 'ListMd'
  | 'MapMd'
  | 'PencilMd'
  | 'PhoneLg'
  | 'ReportsMd'
  | 'SearchByImageIconMd'
  | 'ThumbsUpDownMd';

export type ButtonIconName =
  | 'AddMd'
  | 'DocumentMd'
  | 'DollarSignMd'
  | 'DownloadMd'
  | 'FilterMd'
  | 'HomeHandLg'
  | 'HomeMd'
  | 'HomeMoneyMd'
  | 'LocationMd'
  | 'SearchMd';

export interface ListingImage {
  alt: string;
  caption?: string | null;
  jpgUri: string;
  webpUri: string;
  searchByImageButton?: WebLinkProps;
}

export interface AerialImage {
  alt: string;
  caption?: string | null;
  uri: string;
}

export interface Badge {
  text: string;
  variant: BadgeVariant;
}

export interface TitleWithSourceLevel {
  display?: string;
  sourceLevel: number;
}

export const isListingImage = (image: ListingImage | AerialImage): image is ListingImage =>
  'webpUri' in image || 'jpgUri' in image;
